import { action } from 'satcheljs';
import type { CalendarReadFormInitializationConfig } from 'owa-calendar-helpers-types/lib/CalendarReadFormInitializationConfig';

export interface OpenCalendarItemWithConfirmationActionMessage {
    config: CalendarReadFormInitializationConfig;
}

export const openCalendarItemWithConfirmation: (
    config: CalendarReadFormInitializationConfig
) => OpenCalendarItemWithConfirmationActionMessage = action(
    'openCalendarItemWithConfirmation',
    (
        config: CalendarReadFormInitializationConfig
    ): OpenCalendarItemWithConfirmationActionMessage => ({
        config,
    })
);
